// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1pYsO","header":"ReportDetails_header__1bOsf","title":"ReportDetails_title__1P1za","left":"ReportDetails_left__DSsRO"};